export default InputToArray;

function InputToArray() {}

InputToArray.formWord = function (data) {
  console.log(data);
  let StartWord = data.startCode[0];
  let EndWord = data.endCode[0];
  let StartNum = Number(data.startCode[1]);
  let EndNum = Number(data.endCode[1]);
  // let StartWord = data.startCode.match(/^[a-z|A-Z]+/gi);
  // let EndWord = data.endCode.match(/^[a-z|A-Z]+/gi);
  // let StartNum = data.startCode.match(/\d+$/gi);
  // let EndNum = data.endCode.match(/\d+$/gi);
  let arr = [];
  console.log(StartWord,EndWord,StartNum,EndNum)
  for (let i = StartWord.charCodeAt(0); i < EndWord.charCodeAt(0) + 1; i++) {
    for (let v = 1; v < 10; v++) {
      arr.push(String.fromCharCode(i) + v);
    }
  }
  arr = arr.slice(StartNum - 1, arr.length - 9 + EndNum);
  return arr;
};

InputToArray.formNum = function (data) {
  let arr = [];
  let numStartNum = Number(data.startCode);
  let numEndNum = Number(data.endCode);
  for (let i = numStartNum; i < numEndNum + 1; i++) {
    if (i < 10) {
      arr.push("0" + String(i));
    } else {
      arr.push(String(i));
    }
  }
  return arr;
};
